import React, { useEffect, useState } from "react"; 
import { Link, useLocation, useNavigate } from "react-router-dom";
import NoData from "../../../components/NoData/Index";
import { Header } from "../../../components/SpearParts/Layouts/Header";
import { Footer } from "../../../components/SpearParts/Layouts/Footer";
import { RentalSearchSection } from "../../../components/Rental/Layout/RentalSearchSection";
import Axios from "../../../axios/axios"; // for fetching category by ID

export default function RentalSubCategory() {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const categoryId = searchParams.get("categoryId");

  const initialFilters = location.state?.selectedFilters || {};

  const [categoryData, setCategoryData] = useState(location.state?.category || {});
  const [subcategories, setSubcategories] = useState([]);

  // Fetch category if not passed in state
  useEffect(() => {
    const fetchCategory = async () => {
      if (!categoryData._id && categoryId) {
        try {
          const res = await Axios.get(`/category/get/${categoryId}`);
          setCategoryData(res.data);
        } catch (error) {
          console.error("Error fetching category:", error);
        }
      }
    };
    fetchCategory();
  }, [categoryId, categoryData._id]);

  // Set subcategories whenever categoryData changes
  useEffect(() => {
    if (categoryData?.subcategories?.length > 0) {
      setSubcategories(categoryData.subcategories);
    } else {
      setSubcategories([]);
    }
  }, [categoryData]);

  const handleSubCategoryClick = (subcategory) => {
    const updatedFilters = {
      ...initialFilters,
      categoryId: categoryId,  // parent category stays same
      subcategoryId: subcategory._id
    };

    navigate(
      `/rental/products?${new URLSearchParams(updatedFilters).toString()}`,
      { state: { selectedFilters: updatedFilters } }
    );
  };

  return (
    <div>
      <Header />
      <section id="rental-banner" style={{ width: "90%", margin: "auto" }}>
        <div className="container">

          {/* Search Filter Bar */}
          <RentalSearchSection initialFilters={initialFilters} />

          <div className="row d-none d-lg-flex category-single-page-container">
            <div className="col-lg-12">
              {/* Back Button */}
              <Link to="/rental/category" className="back">
                <i className="fa fa-long-arrow-left"></i> Back
              </Link>

              {/* Subcategory Grid */}
              <div className="category-grid mt-2">
                {subcategories.length === 0 ? (
                  <NoData />
                ) : (
                  subcategories.map((sub, index) => (
                    <div
                      key={index}
                      className="category-item"
                      onClick={() => handleSubCategoryClick(sub)}
                      style={{ cursor: "pointer" }}
                    >
                      <div className="d-flex flex-column align-items-center">
                        <img
                          src={sub.image || sub.images?.[0]}
                          alt={sub.name}
                          style={{
                            width: "100px",
                            height: "100px",
                            objectFit: "cover",
                            borderRadius: "8px",
                            marginBottom: "10px"
                          }}
                        />
                        <h6>{sub.name}</h6>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>

        </div>
      </section>
      <Footer />
    </div>
  );
}
